import { useLanguage } from "assets/languages";
import BRAND from "constants/brand";
import { LOCALES } from "constants/locales";

export const CURRENCY = {
  KRW: "KRW",
  JPY: "JPY",
}

export const makeMoneyText = (
  money: number, 
  threshold: number = 10000, 
  underThresholdCallback: (moneyText:string) => string,
  overThresholdCallback: (moneyText:string) => string
): string => {
  const numValue = Number(money);
  const formatWithCommas = (num: number): string => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  if (numValue >= threshold && numValue % threshold === 0) {
    const manValue = Math.floor(numValue / threshold);
    return overThresholdCallback(formatWithCommas(manValue));
  }
  return underThresholdCallback(formatWithCommas(numValue));
};

export const getCurrencySuffixByCountry = () => {
  const language = useLanguage();
  switch (process.env.LOCALE) {
    case LOCALES.KO:
      return language.common.currencyUnitKRW
    case LOCALES.JA:
      return language.common.currencyUnitJPY
    default:
      return ""
  }
}

export const getCurrencySuffixByBrand = (settings:any) => {
  return settings.currencyText ?? '[NO_UNIT]'
}

export const getCurrencySuffixByCurrency = (currency:string) => {
  const language = useLanguage();
  switch (currency) {
    case CURRENCY.KRW:
      return language.common.currencyUnitKRW
    case CURRENCY.JPY:
      return language.common.currencyUnitJPY
    default:
      return ''
  }
}

/**
 * 일본/한국 서버에서 원화/엔화 결제 브랜드 금액 계산시 사용
 * 
 * @param brandCurrency brand.currency
 * @returns 
 */
export const getCurrencyMultiplier = (brandCurrency:string) => {
  if (brandCurrency === BRAND.CURRENCY.KRW && process.env.LOCALE === LOCALES.JA) {
    return 10
  } else if (brandCurrency === BRAND.CURRENCY.JPY && process.env.LOCALE === LOCALES.KO) {
    return 0.1
  }
  return 1
}